/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon} from '../../../helpers'
import {useAuth} from '../../../../app/modules/auth'

type Props = {
  className: string
}

const AdminAnalyticsWidget1: React.FC<Props> = ({className}) => {
  const {currentUser, logout} = useAuth()
  return <div className={`card ${className}`}></div>
}

export {AdminAnalyticsWidget1}
